import { X } from 'lucide-react';
import { Controller, type FieldPath, type FieldValues } from 'react-hook-form';
import { Button } from '@/components/Button';
import type { FormProps } from '@/hooks/useZodForm';
import { Combobox, type ComboboxOptions } from '../Combobox';
import { FieldLabel } from './FieldLabel';

interface FormComboboxProps<TData extends FieldValues, TValue extends number | string> {
  label?: string;
  fieldName: FieldPath<TData>;
  formProps: FormProps<TData>;
  options: ComboboxOptions<TValue>;
  clearable?: boolean;
  isLoading?: boolean;
}

export function FormCombobox<TData extends FieldValues, TValue extends number | string>(
  props: FormComboboxProps<TData, TValue>
) {
  const { label, fieldName, formProps, options, clearable = false, isLoading } = props;
  const { errors } = formProps;
  const error = errors[fieldName]?.message as string | undefined;

  return (
    <FieldLabel label={label} error={error}>
      <Controller
        control={formProps.control}
        name={fieldName}
        render={({ field }) => (
          <div className="flex items-center gap-2">
            <div className="min-w-0 flex-1">
              <Combobox
                value={field.value}
                onChange={field.onChange}
                options={options}
                isLoading={isLoading}
              />
            </div>
            {clearable && field.value != null && (
              <Button
                variant="outline"
                icon={X}
                aria-label={`Retirer ${label ?? 'la valeur'}`}
                onClick={() => field.onChange(null)}
              />
            )}
          </div>
        )}
      />
    </FieldLabel>
  );
}
